const ExtendedSliderData = cc.Class({
    name: 'ExtendedSliderData',
    properties: {
        scaleWidth: false,
        scaleHeight: false,
        node: cc.Node
    }
});


cc.Class({
    extends: cc.Slider,

    properties: {
        sliderData: [ExtendedSliderData]
    },

    onLoad () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');

        this.resizeManager.appendNode(this);
    },

    onDestroy () {
        if (this.resizeManager) {
            this.resizeManager.removeNode(this);
        }
    },

    onEnable () {
        this._super();
        this.onViewResize();
    },

    onViewResize () {
        this.unscheduleAllCallbacks();

        this.scheduleOnce(() => {
            this._updateHandlePosition();
        }, 0.05);
    },

    /**
     * Override private function
     */
    _updateHandlePosition () {
        const progress = this.progress;
        
        this.sliderData.forEach(data => {
            if (data.scaleWidth) {
                data.node.width = this.node.width;
                data.node.scaleX = 1 * progress; 
            }
            if (data.scaleHeight) {
                data.node.scaleY = 1 * progress; 
            }
        })
        this._super();
    }
});
